"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmptyTextField = exports.isSimpleNode = exports.isRichNode = exports.findElement = void 0;
const slateTypes_1 = require("../types/slateTypes");
const findElement = (editor, path) => {
    let element = null;
    let elementChildren = editor.children;
    path.forEach((index) => {
        element = elementChildren[index];
        if (element && 'children' in element) {
            elementChildren = element.children;
        }
        else {
            throw new Error('No element found at provided location');
        }
    });
    return element;
};
exports.findElement = findElement;
const isRichNode = (node) => node.type === slateTypes_1.CustomElementType.RichText;
exports.isRichNode = isRichNode;
const isSimpleNode = (node) => node.type === slateTypes_1.CustomElementType.SimpleText;
exports.isSimpleNode = isSimpleNode;
const isEmptyTextField = (location, editor) => {
    const textFieldElement = (0, exports.findElement)(editor, location);
    if (!textFieldElement)
        return false;
    if (textFieldElement.type !== slateTypes_1.CustomElementType.RichText &&
        textFieldElement.type !== slateTypes_1.CustomElementType.SimpleText)
        return false;
    if (textFieldElement.children.length !== 1)
        return false;
    if (textFieldElement.children[0].type !== slateTypes_1.CustomElementType.TextBlock)
        return false;
    if (textFieldElement.children[0].children.length !== 1)
        return false;
    if (textFieldElement.children[0].children[0].text !== '')
        return false;
    return true;
};
exports.isEmptyTextField = isEmptyTextField;
